import React, { useEffect, useRef } from 'react';
import BRAND from '../brand';
import { useCatalogLabels, labelsPending } from '../catalogLabels';

function Header({ showTabs, catalogMode, onCatalogModeChange }) {
  const ref = useRef(null);
  const labels = useCatalogLabels();
  const pending = labelsPending(labels);

  // Высота липкой шапки → CSS-переменная: под неё позиционируется полоса категорий
  // (FilterChips) и отступ прокрутки к заголовку раздела. Раньше мерили в эффекте без
  // зависимостей — значение бралось только на рендерах Header, то есть до загрузки
  // фирменного шрифта и логотипа. У Букетберри шапка выше стемсовской, и заголовок
  // раздела уезжал под неё (TASK_STOREFRONT_CATEGORY_SCROLL, 15.09.2026).
  // ResizeObserver пересчитывает на каждое изменение высоты: шрифт, поворот экрана,
  // safe-area в Telegram.
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const apply = () => {
      document.documentElement.style.setProperty('--header-height', el.offsetHeight + 'px');
    };
    apply();
    if (typeof ResizeObserver === 'undefined') return undefined;   // старые вебвью — как раньше
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <header className="header" ref={ref}>
      {/* Фирменная лента вордмарка. По умолчанию обёртка прозрачна (вся шапка
          на фирменном цвете — вид Блума); у Стемса CSS делает из неё узкую
          жёлтую полосу, а табы уходят на белое (референс Bunch). */}
      <div className="header-brand-strip">
        {BRAND.logo?.type === 'image' ? (
          <img
            className="logo"
            src={BRAND.logo.src}
            alt={BRAND.name}
            style={{ height: BRAND.logo.height || 24, display: 'block' }}
          />
        ) : (
          <div className="logo">{BRAND.name}</div>
        )}
        {BRAND.tagline && <div className="header-tagline">{BRAND.tagline}</div>}
      </div>
      {showTabs && (
        <div className="catalog-tabs" style={{ display: 'flex', gap: 8, marginTop: 10 }}>
          {[
            { key: 'products', label: labels.products },
            { key: 'bouquets', label: labels.bouquets },
            { key: 'subscription', label: labels.subscription },
          ].map(({ key, label }) => (
            <button
              key={key}
              onClick={() => onCatalogModeChange?.(key)}
              className={`catalog-tab${catalogMode === key ? ' active' : ''}`}
            >
              <span style={pending ? { visibility: 'hidden' } : undefined}>{label}</span>
            </button>
          ))}
        </div>
      )}
    </header>
  );
}

export default Header;
